import React, { useState } from 'react';
import { Calendar, User } from 'lucide-react';
import VideoFrame from '../components/VideoFrame';
import { debates } from '../mock';

const Debates = () => {
  const [selectedTopic, setSelectedTopic] = useState('All');
  const topics = ['All', 'Existence of God', 'Free Grace Debates', 'Trinity', 'Biblical Slavery','Random Topic Debates'];

  const filteredDebates = selectedTopic === 'All' 
    ? debates 
    : debates.filter(debate => debate.topic === selectedTopic);

  return (
    <div className="page-container">
      <section className="section-container">
        <h1 className="display-large page-title">Debates</h1>
        <p className="body-large page-subtitle">
          Public debates defending biblical Christianity and Free Grace theology.
        </p>

        {/* Topic Filter */}
        <div className="debate-filters">
          {topics.map((topic) => (
            <button
              key={topic}
              onClick={() => setSelectedTopic(topic)}
              className={`filter-btn ${selectedTopic === topic ? 'active' : ''}`}
            >
              {topic}
            </button>
          ))}
        </div>

        {/* Debates List */}
        <div className="debates-list">
          {filteredDebates.map((debate) => (
            <div key={debate.id} className="debate-card-with-frame">
              <div className="debate-video-section">
                <VideoFrame 
                  videoUrl={debate.videoUrl}
                  title={debate.title}
                  logoPosition="bottom-right"
                />
              </div>
              
              <div className="debate-card-content">
                <span className="debate-topic-tag">{debate.topic}</span>
                <h3 className="heading-2">{debate.title}</h3>
                <p className="body-medium">{debate.description}</p>
                
                <div className="debate-card-meta">
                  <div className="meta-item">
                    <User size={16} />
                    <span className="body-small">vs {debate.opponent}</span>
                  </div>
                  <div className="meta-item">
                    <Calendar size={16} />
                    <span className="body-small">{debate.date}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredDebates.length === 0 && (
          <div className="no-results">
            <p className="body-large">No debates found for this topic.</p>
          </div>
        )}
      </section>
    </div>
  );
};

export default Debates;
